export const SIMPLE_NATIONAL = 'simple_national';
export const MEI = 'mei';
export const PRESUMED_PROFIT = 'presumed_profit';
export const REAL_PROFIT = 'real_profit';

export const taxRegimes = Object.freeze({
  [SIMPLE_NATIONAL]: 'Simples Nacional',
  [MEI]: 'Micro Empreendedor Individual - MEI',
  [PRESUMED_PROFIT]: 'Lucro Presumido',
  [REAL_PROFIT]: 'Lucro Real',
});

export function getName(value) {
  return taxRegimes[value];
}
